export default {
  fields: {
    status: { type: 'string' },
    first_name: { type: 'string' },
    last_name: { type: 'string' },
    company: { type: 'string' },
    email: { type: 'string' },
    phone: { type: 'string' },
    duplicate_of_caterer_id: { type: 'integer' },
    hubspot_deal_id: { type: 'string', readOnly: true },
    hubspot_contact_id: { type: 'string', readOnly: true },
    hubspot_synced_at: { type: 'date', readOnly: true },
    hubspot_last_error: { type: 'string', readOnly: true },
    created_at: { type: 'date', readOnly: true },
    updated_at: { type: 'date', readOnly: true },
  },
}
